import { GET_NOTIFICATIONCOUNT_REQUESTED, GET_NOTIFICATIONSEEN_REQUESTED, GET_NOTIFICATION_REQUESTED } from "resources/actionTypes";

export function getNotification(data) {
  return {
    type: GET_NOTIFICATION_REQUESTED,
    payload:data
  };
}

export function getNotificationCount(data) {
  return {
    type: GET_NOTIFICATIONCOUNT_REQUESTED,
    payload:data
  };
}

export function getNotificationSeen(data) {
  return {
    type: GET_NOTIFICATIONSEEN_REQUESTED,
    payload:data
  };
}